import { APIService } from '../api/apiService.js';
import {
  GetActivityLogsPayload,
  GetActivityLogsResponse,
} from '../interfaces/ActivityLogService';

export class ActivityLogService extends APIService {
  /**
   * @desc Get files
   * @param payload
   * @return {Promise<* | undefined>}
   */
  getActivityLogs(
    payload: GetActivityLogsPayload
  ): Promise<GetActivityLogsResponse> {
    return this.request('/getlogs', 'POST', { ...payload });
  }
}
